<div class="empty-request-icon"></div>
<h2>Search or filter applied, some items are hidden</h2>
<a (click)="clearFilter.emit()"> Clear filters </a>
